// src/utils/authLogout.js

import { useEffect, useRef } from "react";
import { getAuth } from "firebase/auth";
import { handleLogout } from "../utils/handleLogout";

const INACTIVITY_TIME = 2 * 60 * 60 * 1000; // ✅ 2 Hours


export default function AuthLogout() {
     const auth = getAuth();
     const timeoutRef = useRef(null);

     useEffect(() => {
          const resetTimer = () => {
               if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
               }

               timeoutRef.current = setTimeout(() => {
                   handleLogout('/login');
                    // toasted.error("Session expired due to inactivity.");
               }, INACTIVITY_TIME);
          };

          // Activity events
          window.addEventListener("mousemove", resetTimer);
          window.addEventListener("keydown", resetTimer);
          window.addEventListener("scroll", resetTimer);
          window.addEventListener("click", resetTimer);

          // Start timer initially
          resetTimer();

          return () => {
               if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
               }

               window.removeEventListener("mousemove", resetTimer);
               window.removeEventListener("keydown", resetTimer);
               window.removeEventListener("scroll", resetTimer);
               window.removeEventListener("click", resetTimer);
          };
     }, [auth]);
}